module.exports = __webpack_public_path__ + "img/new-message-slogan.a5a2e43b.png";